<div class="_bg-white _mt-2 _mb-3 _p-5 _shadow-light _flex _items-center _gap-4"
    [ngStyle]="{opacity: opacity}">
    <div *ngIf="useAvatarPlaceholder"
        class="_placeholder-image-avatar">
        <img class="_h-full _w-full" src="assets/illustration/profile.svg">
    </div>

   <div *ngIf="!useAvatarPlaceholder" class="_placeholder-field _h-20"></div>

   <div class="_flex _flex-col _gap-2">
       <div class="_flex _gap-2">
           <div class="_placeholder-field"></div>
           <div class="_placeholder-field xs-max:_hidden"></div>
       </div>
       <div class="_placeholder-field"></div>
       <div class="_placeholder-field"></div>
    </div>
</div>
